(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ttp-restock"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ttp-restock')) {
    customElements.define('ttp-restock', class extends HTMLElement {
      connectedCallback() {
        if (this.dataset.bound) return;
        this.dataset.bound = 'true';
        const form = this.querySelector('form');
        const button = this.querySelector('button');
        if (this.dataset.enabled !== 'true') return;
        button.disabled = false;
        form.addEventListener('submit', async (event) => {
          event.preventDefault();
          if (button.disabled || !form.reportValidity()) return;
          const error = this.querySelector('.ttpRestock__error');
          const success = this.querySelector('.ttpRestock__success');
          error.hidden = true;
          button.disabled = true;
          form.setAttribute('aria-busy', 'true');
          const controller = new AbortController();
          const timeout = setTimeout(() => controller.abort(), 15000);
          try {
            const intent = {
              shopify_product_id: Number(this.dataset.productId),
              shopify_variant_id: Number(this.dataset.variantId),
              channel: 'email', quantity: 1, source: 'api'
            };
            if (this.dataset.marketId) intent.shopify_market_id = Number(this.dataset.marketId);
            const response = await fetch('https://app.stoqapp.com/api/v1/intents.json', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', 'X-Shopify-Shop-Domain': this.dataset.shop },
              credentials: 'omit',
              signal: controller.signal,
              body: JSON.stringify({
                intent,
                customer: { email: form.elements.email.value.trim(), accepts_marketing: false, locale: this.dataset.locale }
              })
            });
            const data = await response.json();
            const saved = Array.isArray(data.intents) && data.intents.some(item =>
              item.id && String(item.shopify_variant_id) === this.dataset.variantId);
            if (!response.ok || data.errors?.length || !saved) throw new Error('Signup not confirmed');
            form.hidden = true;
            success.hidden = false;
            success.focus();
          } catch {
            error.textContent = this.dataset.error;
            error.hidden = false;
            button.disabled = false;
          } finally {
            clearTimeout(timeout);
            form.removeAttribute('aria-busy');
          }
        });
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
